import VideoBox from '@/components/molecules/VideoBox';

import type { LocationVideoCage } from '../locationVideoStore';

import styles from '../LocationVideo.module.scss';

interface ScreensProps {
    activeCages: LocationVideoCage[];
    onlyViewMode: boolean;
}

/** The video of every pen this user streams, or, in view mode, every live stream. */
export default function Screens({ activeCages, onlyViewMode }: ScreensProps) {
    return (
        <div className={styles.videoGrid}>
            {activeCages
                ?.filter(
                    (cage) =>
                        cage.isButtonSelected || (cage.muxData?.status === 'active' && onlyViewMode)
                )
                .map((cage) => (
                    <VideoBox
                        cageName={cage?.cageName}
                        key={cage?.bioscopeId}
                        userId={cage?.muxData?.userId ?? undefined}
                        videoState={cage?.muxData?.status || ''}
                        videoId={`video-id-${cage?.bioscopeId}`}
                        videoSrc={cage?.muxData?.playbackId ?? undefined}
                        timeRemaining={300}
                        bioscopeData={cage?.bioscopeData}
                    />
                ))}
        </div>
    );
}
